export const NON_INTERACTIVE_UI_PROMOTION_PAGE_TITLE =
    'NON_INTERACTIVE_UI_PROMOTION_PAGE_TITLE';
export const NON_INTERACTIVE_UI_PROMOTION_PAGE_SUB_TITLE =
    'NON_INTERACTIVE_UI_PROMOTION_PAGE_SUB_TITLE';
export const NON_INTERACTIVE_UI_PROMOTION_PAGE_DESCRIPTION =
    'NON_INTERACTIVE_UI_PROMOTION_PAGE_DESCRIPTION';
export const WATCH_THE_PROMO_BUTTON = 'WATCH_THE_PROMO_BUTTON';
